export const clientLogosAboutUs = [
    {
      id: 1,
      src: "https://www.piloggroup.com/img/Client%20Logos/new/abu-dhabi-airport-logo.jpg",
      alt: "Abu Dhabi Airport",
      category: "airport",
    },
    {
      id: 2,
      src: "https://piloggroup.com/img/Client%20Logos/Aeronautical-Defence/Al_Maktoum_Airports.png",
      alt: "Al Maktoum Airports",
      category: "airport",
    },
    {
      id: 3,
      src: "https://www.piloggroup.com/img/Client%20Logos/new/riyadh-airport-logo.jpg",
      alt: "Riyadh Airport",
      category: "airport",
    },
    {
      id: 4,
      src: "https://piloggroup.com/img/Client%20Logos/recent-logos/ESA.jpg",
      alt: "ESA",
      category: "aeronautical",
    },
    {
      id: 5,
      src: "https://piloggroup.com/img/Client%20Logos/Cement/Aditya_MP_Birla%20Group.jpg",
      alt: "Aditya Birla Group",
      category: "cement",
    },
    {
      id: 6,
      src: "https://piloggroup.com/img/Client%20Logos/Cement/Birla_Cement.jpg",
      alt: "Birla Cement",
      category: "cement",
    },
    {
      id: 7,
      src: "https://piloggroup.com/img/Client%20Logos/Cement/Birla_White_Cement.jpg",
      alt: "Birla White Cement",
      category: "cement",
    },
    {
      id: 8,
      src: "https://piloggroup.com/img/Client%20Logos/recent-logos/nuvoco-new-logo.png",
      alt: "Nuvoco",
      category: "cement",
    },
    {
      id: 9,
      src: "https://piloggroup.com/img/Client%20Logos/recent-logos/ppc-cement.svg",
      alt: "PPC Cement",
      category: "cement",
    },
    {
      id: 10,
      src: "https://piloggroup.com/img/Client%20Logos/Cement/UltraTech.png",
      alt: "UltraTech Cement",
      category: "cement",
    },
    {
      id: 11,
      src: "https://piloggroup.com/img/Client%20Logos/new/logos-110.png",
      alt: "Client Logo 110",
      category: "other",
    },
    {
      id: 12,
      src: "https://piloggroup.com/img/Client%20Logos/new/logos-106.png",
      alt: "Client Logo 106",
      category: "other",
    },
    {
      id: 13,
      src: "https://piloggroup.com/img/Client%20Logos/Chemicals-Refineries/HZL.jpg",
      alt: "HZL",
      category: "chemicals",
    },
  ];